var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.8615 2.59972H20.0507V1.81085C20.0507 0.811919 19.1668 0 18.079 0C16.9905 0 16.1073 0.811919 16.1073 1.81085V2.59906H14.0839V1.81085C14.0839 0.811919 13.2 0 12.1122 0C11.0245 0 10.1406 0.811919 10.1406 1.81085V2.59906H8.11717V1.81085C8.11717 0.811919 7.23323 0 6.14548 0C5.05772 0 4.17378 0.811919 4.17378 1.81085V2.59906H3.13846C1.40825 2.59906 0 3.8548 0 5.39765V21.2014C0 22.7443 1.40825 24 3.13846 24H20.8615C22.5925 24 24 22.7443 24 21.2014V5.39765C24 3.85546 22.5918 2.59972 20.8615 2.59972ZM17.215 1.81085C17.215 1.35715 17.6027 0.987736 18.079 0.987736C18.5561 0.987736 18.943 1.35715 18.943 1.81085V5.03482C18.943 5.48852 18.5561 5.85793 18.079 5.85793C17.6027 5.85793 17.215 5.48852 17.215 5.03482V1.81085ZM11.2482 1.81085C11.2482 1.35715 11.6359 0.987736 12.1122 0.987736C12.5886 0.987736 12.9762 1.35715 12.9762 1.81085V5.03482C12.9762 5.48852 12.5886 5.85793 12.1122 5.85793C11.6359 5.85793 11.2482 5.48852 11.2482 5.03482V1.81085ZM5.28074 1.81085C5.28074 1.35715 5.66843 0.987736 6.14474 0.987736C6.62105 0.987736 7.00874 1.35715 7.00874 1.81085V5.03482C7.00874 5.48852 6.62105 5.85793 6.14474 5.85793C5.66843 5.85793 5.28074 5.48852 5.28074 5.03482V1.81085ZM22.1538 21.2021C22.1538 21.8375 21.5742 22.3544 20.8615 22.3544H3.13846C2.42585 22.3544 1.84615 21.8375 1.84615 21.2021V6.71529H22.1538V21.2021Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90104 9.63135H3.50781V12.3239H6.90104V9.63135Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4306 9.63135H8.03662V12.3239H11.4306V9.63135Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 9.63135H12.5693V12.3239H15.9626V9.63135Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4926 9.63135H17.0986V12.3239H20.4926V9.63135Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90104 13.2251H3.50781V15.9157H6.90104V13.2251Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4306 13.2251H8.03662V15.9157H11.4306V13.2251Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 13.2251H12.5693V15.9157H15.9626V13.2251Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4926 13.2251H17.0986V15.9157H20.4926V13.2251Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.90104 16.8179H3.50781V19.5085H6.90104V16.8179Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4306 16.8179H8.03662V19.5085H11.4306V16.8179Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9626 16.8179H12.5693V19.5085H15.9626V16.8179Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4926 16.8179H17.0986V19.5085H20.4926V16.8179Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.00770366aa3e2532ab2185a7a9af153a.svg";
export { ForwardRef as ReactComponent };